import React from 'react';
import PropTypes from 'prop-types';
// import ListadoDeSolicitudesAprobadas from './SolicitudesEnviadas'
import SolicitudesNuevasExtranjero from './solicitudesNuevas';
// import ListadoDeSolicitudesRechazadas from './SolicitudesRechazadas';
import Title from 'components/TitleWithIcon';

import { CheckCircleOutline, LibraryAdd, Group, HighlightOff } from '@material-ui/icons';
import {Box, Tab, Tabs, AppBar, makeStyles} from '@material-ui/core';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`} {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    backgroundColorTab:{
        backgroundColor: '#ededed',
    }
}));

export default function SolicitudesExtranjero(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    var authenticated =props.authenticated;

    return (
        <div className={classes.root}>
            <Title title="Gestiones de Empadronamiento del extranjero" icon={"/menu/Document.png"}/>
            <AppBar position="static" color="#ededed" elevation={0}>
                <Tabs 
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    <Tab label="Solicitudes Nuevas" icon={<LibraryAdd />} {...a11yProps(0)} />
                    <Tab label="Solicitudes Aprobadas" icon={<CheckCircleOutline />} {...a11yProps(1)} />
                    <Tab label="Solicitudes Rechazadas" icon={<HighlightOff />} {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            {/* Nuevas Solicitudes */}
            <TabPanel value={value} index={0} className={classes.backgroundColorTab}>
                <SolicitudesNuevasExtranjero  authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de solicitudes aprobadas */}
            <TabPanel value={value} index={1} className={classes.backgroundColorTab}>
                {/* <ListadoDeSolicitudesAprobadas authenticated={authenticated} currentUser={props.currentUser}/> */}
            </TabPanel>
            {/* Listado de solicitudes rechazadas */}
            <TabPanel value={value} index={2} className={classes.backgroundColorTab}>
                {/* <ListadoDeSolicitudesRechazadas authenticated={authenticated} currentUser={props.currentUser}/> */}
            </TabPanel>
        </div>
    );
}
